import { render, staticRenderFns } from "./DiagnosticCardStatusChip.vue?vue&type=template&id=46d0c5fd"
import script from "./DiagnosticCardStatusChip.vue?vue&type=script&lang=ts"
export * from "./DiagnosticCardStatusChip.vue?vue&type=script&lang=ts"
import style0 from "./DiagnosticCardStatusChip.vue?vue&type=style&index=0&id=46d0c5fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports